/* eslint-disable import/extensions,import/no-unresolved,import/no-unresolved,import/no-duplicates,import/no-named-as-default-member,no-constant-condition,no-console */
/**
 * Gets the repositories of the user from Github
 */
import _ from 'lodash';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import apiConfig from 'utils/apiConfig';
import { combineDateTime } from 'utils/dateUtil';
import { startProgress, endProgress } from 'containers/ProgressBar/actions';
import { mapCountryList, mapCityList } from '../dataMapper/countryMapper';
import {
  GET_CITY_LIST,
  GET_COUNTRY_LIST,
  GET_CLAIM_TYPES,
  VALIDATE_DATE_TIME_OF_EVENT,
} from './constants';
import {
  getCityListSuccess,
  getCountryListSuccess,
  handleFormDataChange,
  getClaimTypeSuccess,
} from './actions';
import { makeSelectAuthToken } from '../../Login/selectors';
import { makeSelectStep5 } from './selectors';
import { makeError } from '../../Wizard/actions';
import { makeSelectPolicyId } from '../../App/selectors';
import { makeSelectPolicyTypeId } from '../../ClaimList/selectors';
import { mapDataForClaimType } from './mapDataForClaimType';
import { makeSelectAppClaimType } from '../../App/selectors';
import { logoutSuccess, setErrorMessageDateValidation } from '../../App/actions';
import isAuthorised from '../../../utils/unauthoriseValidator';
import { resetLoginInfo } from '../../Login/actions';
import { showErrorToastr } from '../../Toastr/actions';

export function* getCountries() {
  // yield put(startProgress());
  // TODO call API to get countries
  try {
    const token = yield select(makeSelectAuthToken());
    const authToken = `bearer ${token}`;
    const requestUrl = `${
      apiConfig.restServiceDomain
      }/api/v1/Countries`;
    const requestOption = {
      method: 'GET',
      headers: {
        Authorization: authToken,
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(request, requestUrl, requestOption);
    if (response.isSuccess) {
      const rs = mapCountryList(response.payload);
      // set data for country list
      yield put(getCountryListSuccess(rs));
      // reset country, city field if old data
      const step5Data = yield select(makeSelectStep5());
      const isCountryFieldValid = _.find(rs, (d) => d.id === step5Data.country);
      if (!isCountryFieldValid && !!step5Data.country) {
        yield put(handleFormDataChange('form.country', ''));
        yield put(handleFormDataChange('form.city', ''));
        yield put(makeError(3));
      }
    }
  } catch (e) {
    console.log(e);
  } finally {
    // yield put(endProgress());
  }
}

export function* getCities({ stringCity, callback }) {
  // yield put(startProgress());
  // TODO call API to get cities
  try {
    const step5Data = yield select(makeSelectStep5());
    const token = yield select(makeSelectAuthToken());
    const authToken = `bearer ${token}`;
    const requestUrl = `${
      apiConfig.restServiceDomain
      }/api/v1/Countries/Cities?countryID=${step5Data.country}&cityName=${stringCity || ''}`;
    const requestOption = {
      method: 'GET',
      headers: {
        Authorization: authToken,
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(request, requestUrl, requestOption);
    if (response.isSuccess) {
      const rs = mapCityList(response.payload);
      yield put(getCityListSuccess(rs));
      if (callback) {
        callback(rs);
      }
    }
  } catch (e) {
    console.log(e);
  } finally {
    // yield put(endProgress());
  }
}
function* loadClaimTypeList() {
  const policyTypeId = yield select(makeSelectPolicyTypeId());
  const claimTypes = yield select(makeSelectAppClaimType());
  yield put(getClaimTypeSuccess(mapDataForClaimType(claimTypes, policyTypeId)));
  // const token = yield select(makeSelectAuthToken());
  // const policyId = yield select(makeSelectPolicyId());
  // const requestURL = `${
  //   apiConfig.restServiceDomain
  //   }/api/v1/policies/${policyId}/claimTypes`;
  // const requestOptions = {
  //   headers: {
  //     Authorization: `bearer ${token}`,
  //   },
  // };
  //
  // try {
  //   const res = yield call(request, requestURL, requestOptions);
  //   const policyTypeId = yield select(makeSelectPolicyTypeId());
  //   yield put(getClaimTypeSuccess(mapDataForClaimType(res.payload, policyTypeId)));
  // } catch (e) {
  //   console.log(e);
  // } finally {
  //   // yield put(endProgress());
  // }
}

function* validateEventDateTime({ fieldName }) {
  try {
    yield put(startProgress());
    const token = yield select(makeSelectAuthToken());
    const policyId = yield select(makeSelectPolicyId());
    const step5Data = yield select(makeSelectStep5());
    const { dateOfEvent, timeOfEvent } = step5Data;
    if (!dateOfEvent || !timeOfEvent) {
      return;
    }
    const incidentDate = combineDateTime(dateOfEvent, timeOfEvent);
    const data = { incidentDate };
    const requestUrl = `${
      apiConfig.restServiceDomain
      }/api/v1/policies/${policyId}/claims/validateIncidentDate`;
    const requestOption = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `bearer ${token}`,
      },
      method: 'POST',
      body: JSON.stringify(data),
    };
    const response = yield call(request, requestUrl, requestOption);
    if (response.isSuccess) {
      if (!response.payload.isValid) {
        yield put(handleFormDataChange(fieldName, null));
        yield put(setErrorMessageDateValidation(response.payload.errorMessage));
      } else {
        yield put(setErrorMessageDateValidation(''));
      }
    }
  } catch (err) {
    if (!isAuthorised(err.response)) {
      yield put(resetLoginInfo());
      yield put(logoutSuccess());
    } else {
      yield put(showErrorToastr(err.message));
    }
  } finally {
    yield put(endProgress());
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* step5() {
  yield [
    takeLatest(GET_COUNTRY_LIST, getCountries),
    takeLatest(GET_CITY_LIST, getCities),
    takeLatest(GET_CLAIM_TYPES, loadClaimTypeList),
    takeLatest(VALIDATE_DATE_TIME_OF_EVENT, validateEventDateTime),
  ];
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step5/saga.js